import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import TabSection from '../components/TabSection';
import { SITE_URL } from '../config';
import form from '../assets/forms/pdfForms/Disability-Tax-Credit-Certificate.pdf';
import formFr from '../assets/forms/pdfForms/FR/Crédit-d\'impôt-pour-personnes-handicapées.pdf';
import FormViewer from '../components/FormViewer';
import page1 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-1.jpg';
import page2 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-2.jpg';
import page3 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-3.jpg';
import page4 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-4.jpg';
import page5 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-5.jpg';
import page6 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-6.jpg';
import page7 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-7.jpg';
import page8 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-8.jpg';
import page9 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-9.jpg';
import page10 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-10.jpg';
import page11 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-11.jpg';
import page12 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-12.jpg';
import page13 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-13.jpg';
import page14 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-14.jpg';
import page15 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-15.jpg';
import page16 from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/page-16.jpg';
import page1Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-1.jpg';
import page2Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-2.jpg';
import page3Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-3.jpg';
import page4Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-4.jpg';
import page5Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-5.jpg';
import page6Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-6.jpg';
import page7Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-7.jpg';
import page8Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-8.jpg';
import page9Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-9.jpg';
import page10Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-10.jpg';
import page11Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-11.jpg';
import page12Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-12.jpg';
import page13Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-13.jpg';
import page14Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-14.jpg';
import page15Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-15.jpg';
import page16Fr from '../assets/forms/jpgForms/Disability-Tax-Credit-Certificate/FR/page-16.jpg';

const enPages = [page1, page2, page3, page4, page5, page6, page7, page8, page9, page10, page11, page12, page13, page14, page15, page16];
const frPages = [page1Fr, page2Fr, page3Fr, page4Fr, page5Fr, page6Fr, page7Fr, page8Fr, page9Fr, page10Fr, page11Fr, page12Fr, page13Fr, page14Fr, page15Fr, page16Fr];

const enOverlays = [
  {
    pageIndex: 0,
    sectionId: 'sections.dtc-part-a',
    top: '5%',
    height: '7%',
    videoUrls: ["/ASL/DISC ASL DTC Beginning.mp4", "/LSQ/CIPH form beginning.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.paragraph-1',
    top: '12%',
    height: '26%',
    videoUrls: ["/ASL/DISC ASL DTC Part A and Paragraph 1.mp4", "/LSQ/CIPH - Partie A.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.paragraph-2',
    top: '38%',
    height: '19%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 2.mp4", "/LSQ/CIPH - Paragraph 2.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.basic-necessities',
    top: '57%',
    height: '7%',
    videoUrls: ["/ASL/DISC ASL DTC Indicate which basic necessities explanation.mp4", "/LSQ/CIPH - Indiquez à quels besoins fondamentaux….mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.provide-details',
    top: '64%',
    height: '15.5%',
    videoUrls: ["/ASL/DISC ASL DTC Provide details explanation.mp4", "/LSQ/CIPH - Fournissez des détails sur le soutien….mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.signature',
    top: '79.5%',
    height: '14.5%',
    videoUrls: ["/ASL/DISC ASL DTC Signature.mp4", "/LSQ/CIPH - Signauture.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.paragraph-3',
    top: '7%',
    height: '20.5%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 3.mp4", "/LSQ/CIPH - Paragraph 3.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.paragraph-4',
    top: '27.5%',
    height: '29%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 4.mp4", "/LSQ/CIPH - Paragraph 4.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.part-b',
    top: '68%',
    height: '20.5%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 2,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 3,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 4,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 5,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 6,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 7,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 8,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 9,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 10,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 11,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 12,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 13,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 14,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 15,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
];

// FR overlays start as a copy of EN. Only adjust top/height entries where the
// French form layout differs from the English one.
const frOverlays = [
  {
    pageIndex: 0,
    sectionId: 'sections.dtc-part-a',
    top: '5%',
    height: '9%',
    videoUrls: ["/ASL/DISC ASL DTC Beginning.mp4", "/LSQ/CIPH form beginning.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.paragraph-1',
    top: '14%',
    height: '25%',
    videoUrls: ["/ASL/DISC ASL DTC Part A and Paragraph 1.mp4", "/LSQ/CIPH - Partie A.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.paragraph-2',
    top: '39%',
    height: '18.5%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 2.mp4", "/LSQ/CIPH - Paragraph 2.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.basic-necessities',
    top: '57.5%',
    height: '7.5%',
    videoUrls: ["/ASL/DISC ASL DTC Indicate which basic necessities explanation.mp4", "/LSQ/CIPH - Indiquez à quels besoins fondamentaux….mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.provide-details',
    top: '65%',
    height: '14.5%',
    videoUrls: ["/ASL/DISC ASL DTC Provide details explanation.mp4", "/LSQ/CIPH - Fournissez des détails sur le soutien….mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 0,
    sectionId: 'sections.signature',
    top: '79.5%',
    height: '14.5%',
    videoUrls: ["/ASL/DISC ASL DTC Signature.mp4", "/LSQ/CIPH - Signauture.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.paragraph-3',
    top: '7%',
    height: '20%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 3.mp4", "/LSQ/CIPH - Paragraph 3.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.paragraph-4',
    top: '27%',
    height: '30%',
    videoUrls: ["/ASL/DISC ASL DTC Paragraph 4.mp4", "/LSQ/CIPH - Paragraph 4.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 1,
    sectionId: 'sections.part-b',
    top: '68%',
    height: '20.5%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 2,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 3,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 4,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 5,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 6,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 7,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 8,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 9,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 10,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 11,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 12,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 13,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 14,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
  {
    pageIndex: 15,
    sectionId: 'sections.part-b',
    top: '1%',
    height: '98%',
    videoUrls: ["/ASL/DISC ASL DTC Part B.mp4", "/LSQ/CIPH -Part B.mp4"],
    videoLabels: ["ASL", "LSQ"],
  },
];

function Form1({ activeSectionId, setActiveSectionId, setCurrentVideoUrl, setVideoSidebarOpen, setVideoLabels, setSelectedVideoIndex, setAllVideoUrls, registerSection, unregisterSection }) {
  const { t, i18n } = useTranslation();
  const isFR = i18n.language === 'fr';
  const formImages = isFR ? frPages : enPages;
  const pageOverlays = isFR ? frOverlays : enOverlays;

  return (
    <>
      <Helmet>
        <title>{isFR ? "Crédit d'impôt pour personnes handicapées | deafinfo.ca/fr | ASC-CAD" : 'Disability Tax Credit | deafinfo.ca | CAD-ASC'}</title>
        <meta name="description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:title" content={isFR ? "Crédit d'impôt pour personnes handicapées | deafinfo.ca/fr | ASC-CAD" : 'Disability Tax Credit | deafinfo.ca | CAD-ASC'} />
        <meta property="og:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={isFR ? "Crédit d'impôt pour personnes handicapées | deafinfo.ca/fr | ASC-CAD" : 'Disability Tax Credit | deafinfo.ca | CAD-ASC'} />
        <meta name="twitter:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta name="twitter:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
      </Helmet>
    <section className="wrapper">
              {/* FORMS INTRO SECTION */}
        <section className="mb-5">
          <TabSection
          videoUrls={["/ASL/DISC ASL DTC and who for.mp4", "/LSQ/CIPH intro and who for.mp4"]} videoLabels={["ASL", "LSQ"]}
          sectionId="sections.dtc-form-info"
          activeSectionId={activeSectionId}
          setActiveSectionId={setActiveSectionId}
          setCurrentVideoUrl={setCurrentVideoUrl}
          setVideoSidebarOpen={setVideoSidebarOpen}
          setVideoLabels={setVideoLabels}
          setSelectedVideoIndex={setSelectedVideoIndex}
          setAllVideoUrls={setAllVideoUrls}
          isDefault
          registerSection={registerSection}
          unregisterSection={unregisterSection}>

            <h1 className="form-title">{t('form.page1.form-title')}</h1>
            <div style={{ paddingTop: '0.5rem' }} className="flex row gap-5 section-columns form">
              <div className="col section-copy">
                <p>{t('form.page1.form-description')}</p>
                <div className="mt-4">
                  <a href={isFR ? formFr : form} download className="btn-primary btn-download me-4">{t('form.page1.button-1')}</a>
                </div>
              </div>
              <div className="col section-media">
                <div className="section-who">
                  <h3 className="mb-3">{t('form.page1.who-title')}</h3>
                  <ul>
                  <li>{t('form.page1.who-1')}</li>
                  <li>{t('form.page1.who-2')}</li>
                  <li>{t('form.page1.who-3')}</li>
                  </ul>
                  <p><b>{t('form.page1.source')}</b> <a href={t('form.page1.source-link')} target="_blank" rel="noopener noreferrer">{t('form.page1.source-name')}</a></p>
                </div>
              </div>
            </div>
          </TabSection>
        </section>

        <section className="mb-5 form-section position-relative">
          <FormViewer
            formImages={formImages}
            formTitle={t('form.page1.form-title')}
            pageOverlays={pageOverlays}
            activeSectionId={activeSectionId}
            setActiveSectionId={setActiveSectionId}
            setCurrentVideoUrl={setCurrentVideoUrl}
            setVideoSidebarOpen={setVideoSidebarOpen}
            setVideoLabels={setVideoLabels}
            setSelectedVideoIndex={setSelectedVideoIndex}
            setAllVideoUrls={setAllVideoUrls}
            registerSection={registerSection}
            unregisterSection={unregisterSection}
          />

        </section>

    </section>
    </>
  );
}

export default Form1;
